export const transformPayloadData = <T>(data: T) => {
  if (!data) return null
  if (typeof data !== 'object' || Array.isArray(data)) return null
  if (!('totalDocs' in data) || !('docs' in data)) return null
  if (!Array.isArray((data as any).docs)) return null
  if (data.totalDocs === 1) {
    return data.docs[0]
  } else {
    return null
  }
}
